import { useGLTF } from "@react-three/drei";

// Reuse the existing baked alpha contact mask, not the road's lightmap/AO.
// Unlit black preserves the mask regardless of room lighting; no invisible
// depth-writing floor and no input target. The tunnel is rotated 90deg in XR.
export default function CarContactShadow({ x = 0, z = 0 }) {
  const { nodes, materials } = useGLTF("/models/tunnel.glb");
  return <group name="xr-car-contact-shadow" position={[x, 0, z]} rotation={[0, Math.PI / 2, 0]}>
    <mesh name="xr-contact-shadow-mask" renderOrder={-10} geometry={nodes.shadowPlane.geometry} raycast={() => {}}>
      <meshBasicMaterial map={materials.shadowPlane_mat.map} color="black" transparent opacity={0.65}
        depthWrite={false} depthTest polygonOffset polygonOffsetFactor={-1} polygonOffsetUnits={-1} toneMapped={false} fog={false} />
    </mesh>
  </group>;
}
